<template>
    <div class="send-project-status">
        <div class="left">
            <h3>{{statusConfig[statusCode].title}}</h3>
            <p>{{getMessage}}</p>
        </div>
        <div class="right">
            <img width="250" height="170" :src="statusConfig[statusCode].image" alt />
        </div>
    </div>
</template>
<script>
export default {
    name: "send-project-status",
    props: {
        statusCode: Number,//1-派發中，2-派发成功，3-派发失败
        progress: {
            type: Number,
            default: 0
        },//进度数据
        statusConfig: Object
    },
    computed: {
        getMessage() {
            let message = this.statusConfig[this.statusCode];
            console.log('getMessage:', message, this.statusConfig, this.statusCode)
            if (!message) {
                return ""
            }
            // return 'caonima'
            if (typeof message.message === "function") {
                return message.message(this.progress)
            } else {
                return message.message;
            }
        }
    }
}
</script>
<style lang="scss">
.send-project-status {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .left {
        width: calc(100% - 320px);
        float: left;
        padding-right: 28px;
        h3 {
            font-size: 22px;
            color: #ffffff;
            line-height: 36px;
            margin-top: 8px;
        }
        p {
            font-size: 16px;
            color: #ffffff;
            line-height: 1.75em;
            margin-top: 12px;
            white-space: break-spaces;
        }
    }
    .right {
        width: 250px;
        height: 170px;
        float: left;
    }
}
</style>